import { JSX } from 'react';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { IconCtaColoredBoxCard } from '@ahc-digital/component-library';
import { CreateIconCTAColoredBoxCardModel } from './C32IconCTAColoredBoxCard.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { C32IconCTAColoredBoxCardProps } from './C32IconCTAColoredBoxCard.types';

export const Default = (props?: C32IconCTAColoredBoxCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <IconCtaColoredBoxCard
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateIconCTAColoredBoxCardModel(props)}
    />
  );
};
